module.exports = __webpack_public_path__ + "ls.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/ls.svg
// module id = 920
// module chunks = 0